<template>
  <el-submenu :index="getPath() || uniqueid" :show-timeout="100" :popper-append-to-body="true">
    <template slot="title">
      <i v-if="!menu.isOnlyText" :class="`${menu.icon || 'fa fa-folder-o'}`"></i>
      <span slot="title">{{ menu.title }}</span>
    </template>
    <template v-for="(child, childIndex) in menu.children">
      <d2-layout-header-aside-menu-item v-if="child.children === undefined" :menu="child" :isMobileLayer="isMobileLayer"
                                        :key="childIndex"/>
      <d2-layout-header-aside-menu-sub v-else :menu="child" :isMobileLayer="isMobileLayer" :key="childIndex"/>
    </template>
  </el-submenu>
</template>

<script>
import uniqueid from 'lodash.uniqueid'
// 组件
import d2LayoutMainMenuItem from '../menu-item'

export default {
  name: 'd2-layout-header-aside-menu-sub',
  components: {
    'd2-layout-header-aside-menu-item': d2LayoutMainMenuItem
  },
  props: {
    menu: {
      type: Object,
      required: false,
      default: () => {
      }
    },
    isMobileLayer: {
      type: Boolean,
      required: false,
    }
  },
  data() {
    return {
      uniqueid: uniqueid('d2-menu-empty-')
    }
  },
  mounted() {
    this.$children[0].$parent = this.$parent
  },
  methods: {
    getPath() {
      if (this.isMobileLayer && this.menu.mobilePath) {
        return this.menu.mobilePath
      } else {
        return this.menu.path
      }
    }
  }
}
</script>
